import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdDashboard,
  MdHome,
  MdLock,
  MdPowerSettingsNew
} from 'react-icons/md';

// Admin Imports
import MainDashboard from './/views/admin/default';
import Logout from './/views/shared/Logout';
import NewCarrier from './/views/admin/carriers/components/NewCarrier';
import Carriers from './views/admin/carriers/components/Carriers';
// import AddCustomer from './views/admin/customer/components/AddCustomer';
// import Customers from './views/admin/customer/components/Customers';
import NewLuggage from './views/admin/luggage/components/NewLuggage';
import Luggages from './views/admin/luggage/components/Luggages';
import NewManager from './views/admin/manager/components/NewManager';
import Managers from './views/admin/manager/components/Managers';
import CarriersAccess from './views/admin/carriers/components/CarriersAccess';
import ManagersAccess from './views/admin/manager/components/ManagersAccess';
import CarrierLuggages from './views/admin/luggage/components/CarrierLuggages';
import Airlines from './views/admin/airlines/components/Airlines';
import LuggageCount from './views/admin/reports/luggage/LuggageCount';

// Auth Imports
// import SignInCentered from './/views/auth/signIn';

export const adminRoutes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Manage',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    path: '/main',
    collapse: true,
    items: [
      {
        name: 'Airlines',
        layout: '/admin',
        path: '/main/airlines',
        collapse: false,
        component: <Airlines />,
      },
      {
        name: 'Managers',
        path: '/main/managers',
        collapse: true,
        items: [
          {
            name: 'Add Manager',
            layout: '/admin',
            path: '/main/managers/new-manager',
            exact: false,
            component: <NewManager />,
          },
          {
            name: 'View',
            layout: '/admin',
            path: '/main/managers/managers-overview',
            exact: false,
            component: <Managers />,
          },
        ],
      },
      {
        name: 'Carriers',
        path: '/main/carriers',
        collapse: true,
        items: [
          {
            name: 'Add Carrier',
            layout: '/admin',
            path: '/main/carriers/new-carrier',
            exact: false,
            component: <NewCarrier />,
          },
          {
            name: 'View',
            layout: '/admin',
            path: '/main/carriers/carriers-overview',
            exact: false,
            component: <Carriers />,
          },
        ],
      },
      // {
      //   name: 'Customers',
      //   path: '/main/customers',
      //   collapse: true,
      //   items: [
      //     {
      //       name: 'Add Customer',
      //       layout: '/admin',
      //       path: '/main/customers/new-customer',
      //       exact: false,
      //       component: <AddCustomer />,
      //     },
      //     {
      //       name: 'View',
      //       layout: '/admin',
      //       path: '/main/customers/customers-overview',
      //       exact: false,
      //       component: <Customers />,
      //     },
      //   ],
      // },
      {
        name: 'Luggages',
        path: '/main/luggages',
        collapse: true,
        items: [
          {
            name: 'Add Luggage',
            layout: '/admin',
            path: '/main/luggages/new-luggage',
            exact: false,
            component: <NewLuggage />,
          },
          {
            name: 'View',
            layout: '/admin',
            path: '/main/luggages/luggages-overview',
            exact: false,
            component: <Luggages />,
          },
        ],
      }
    ]
  },
  {
    name: 'User Access',
    path: '/access',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Carriers',
        layout: '/admin',
        path: '/access/carriers',
        collapse: false,
        component: <CarriersAccess />,
      },
      {
        name: 'Managers',
        layout: '/admin',
        path: '/access/managers',
        collapse: false,
        component: <ManagersAccess />,
      },
    ]
  },
  {
    name: 'Reports',
    path: '/reports',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Luggage Count',
        layout: '/admin',
        path: '/reports/luggage-count',
        collapse: false,
        component: <LuggageCount />,
      },
    ]
  },
  {
    name: 'Log out',
    layout: '/admin',
    path: '/logout',
    icon: <Icon as={MdPowerSettingsNew} width="20px" height="20px" color="inherit" />,
    component: <Logout />,
  },
];

export const managerRoutes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Manage',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    path: '/main',
    collapse: true,
    items: [
      {
        name: 'Luggages',
        path: '/main/luggages',
        collapse: true,
        items: [
          {
            name: 'Add Luggage',
            layout: '/admin',
            path: '/main/luggages/new-luggage',
            exact: false,
            component: <NewLuggage />,
          },
          {
            name: 'View',
            layout: '/admin',
            path: '/main/luggages/luggages-overview',
            exact: false,
            component: <Luggages />,
          },
        ],
      }
    ]
  },
  {
    name: 'Log out',
    layout: '/admin',
    path: '/logout',
    icon: <Icon as={MdPowerSettingsNew} width="20px" height="20px" color="inherit" />,
    component: <Logout />,
  },
];

export const carrierRoutes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Manage',
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    path: '/main',
    collapse: true,
    items: [
      {
        name: 'Luggages',
        layout: '/admin',
        path: '/main/carrierluggages',
        exact: false,
        component: <CarrierLuggages />,
      }
    ]
  },
  {
    name: 'Log out',
    layout: '/admin',
    path: '/logout',
    icon: <Icon as={MdPowerSettingsNew} width="20px" height="20px" color="inherit" />,
    component: <Logout />,
  },
];

export const routes = [
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <MainDashboard />,
  },
  {
    name: 'Log out',
    layout: '/admin',
    path: '/logout',
    icon: <Icon as={MdPowerSettingsNew} width="20px" height="20px" color="inherit" />,
    component: <Logout />,
  },
];

